import { Component, OnInit } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { AlertBannerService } from 'projects/lib_util/src/lib/services/alert-banner.service';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'spv2-alert-banner',
  templateUrl: './alert-banner.component.html',
  styleUrls: ['./alert-banner.component.scss']
})
export class AlertBannerComponent implements OnInit {
 
  constructor(public readonly alertBannerService: AlertBannerService, private router: Router) { }

  ngOnInit() {
    //For now we always hide alert banner after navigating, can add option we can opt in later if needed.
    this.router.events.pipe(filter(event => event instanceof NavigationStart))
      .subscribe(x => this.alertBannerService.hide());
  }
}
